// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/business/accounts_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { legacyCatalogAccountsDatatable } from "./constants";
import type { LegacyCatalogAccountsDatatableParams, LegacyCatalogAccountsDatatableResult } from "./types";
import { isLegacyCatalogAccountsDatatableResult } from "./validators";

export const getDataTableLegacyCatalogAccountsDatatable = reactQueryTableFetcherAdapter(
  legacyCatalogAccountsDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0 }: LegacyCatalogAccountsDatatableParams
  ): Promise<LegacyCatalogAccountsDatatableResult> => {
    return fetch(
      "/apps/business/accounts_datatable",
      "GET",
      {
        app_group_id: appGroupId,
        groupby,
        limit,
        query: serializeQueryObjects(query),
        start,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isLegacyCatalogAccountsDatatableResult
);
